var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "#8757FF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 8V5.75C5.75 2.89062 8.09375 0.5 11 0.5C13.8594 0.5 16.25 2.89062 16.25 5.75V8H19.25C20.4688 8 21.5 9.03125 21.5 10.25V20C21.5 22.4844 19.4844 24.5 17 24.5H5C2.46875 24.5 0.5 22.4844 0.5 20V10.25C0.5 9.03125 1.48438 8 2.75 8H5.75ZM8 8H14V5.75C14 4.10938 12.6406 2.75 11 2.75C9.3125 2.75 8 4.10938 8 5.75V8ZM2.75 10.25V20C2.75 21.2656 3.73438 22.25 5 22.25H17C18.2188 22.25 19.25 21.2656 19.25 20V10.25H16.25V12.875C16.25 13.5312 15.7344 14 15.125 14C14.4688 14 14 13.5312 14 12.875V10.25H8V12.875C8 13.5312 7.48438 14 6.875 14C6.21875 14 5.75 13.5312 5.75 12.875V10.25H2.75Z",
    fill: "#8757FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.577c36bfc71d77bd569353968bb549a5.svg";
export { ForwardRef as ReactComponent };